export default {
  name: 'BooleanRenderer',
  props: {
    value: { type: Boolean, default: false }
  }
}
